import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { FeatureEnum } from '../../enum/feature.enum';
import { UsageLimitService } from '../../services/usage-limit/usage-limit.service';

/**
 * Libera a rota só se a feature veio no /new-me e ainda há saldo.
 * Sem saldo, volta para a lista. listPath cobre rotas de criar que não terminam em /adicionar (tag-ratoeira).
 */
export function limitsFeatureGuard(feature: FeatureEnum, listPath?: string): CanActivateFn {
    return (_route, state) => {
        const usageLimitService = inject(UsageLimitService);
        const router = inject(Router);

        return usageLimitService.ensureUsageLoaded().pipe(
            map(() => {
                if (usageLimitService.canUseFeature(feature)) {
                    return true;
                }

                const fallback = listPath ?? (state.url.split('?')[0].replace(/\/adicionar\/?$/, '') || '/v2');
                return router.parseUrl(fallback);
            }),
        );
    };
}
